import { BlogPage } from '@/components/postPages/BlogPage';

export default BlogPage;
